import { render, staticRenderFns } from "./UdSelect.vue?vue&type=template&id=ba8864f6&"
import script from "./UdSelect.vue?vue&type=script&lang=js&"
export * from "./UdSelect.vue?vue&type=script&lang=js&"
import style0 from "./UdSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports